import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065835c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reservation-wrap style-one pt-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center pb-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-5 col-lg-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content-title style-six" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Reservation Table?"),
    /*#__PURE__*/_createElementVNode("p", null, "We are open for indoor & outdoor dining.")
  ])
], -1))
const _hoisted_5 = { class: "col-xxl-5 offset-xxl-1 col-lg-6" }
const _hoisted_6 = { class: "option-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-subtitle text-center mb-40" }, [
  /*#__PURE__*/_createTextVNode(" Any Kind Of "),
  /*#__PURE__*/_createElementVNode("span", null, "Food"),
  /*#__PURE__*/_createTextVNode(" Made For "),
  /*#__PURE__*/_createElementVNode("span", null, "Our Customer")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OurCustomer = _resolveComponent("OurCustomer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "btn-one"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Contact us ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_7,
      _createVNode(_component_OurCustomer)
    ])
  ]))
}